<script setup>
  import Authors from "@/components/Authors.vue";

  defineProps({
    blok: Object,
    showReporters: {
      type: Boolean,
      default: false,
    },
  });

  function getStringBetweenMiddleSlashes(str) {
    const parts = str.split('/');
    if (parts.length < 3 || parts.length % 2 === 0) {
      return null; // Not enough slashes or an even number for a single middle
    }
    const middleIndex = Math.floor(parts.length / 2);
    return parts[middleIndex];
  }
</script>

<template>
  <section class="hp-section border-0">
    <v-row class="featured-stories pl-2 pr-2 pa-md-0">
      <v-col
        class="v-col-6 v-col-md-4 story pl-1 pr-1 pl-md-3 pr-md-3 pb-4 pb-md-6"
        v-for="story in blok.stories"
        :key="story._uid"
      >
        <router-link v-if="story.content.component === 'podcast-episode'" :to="{ name: 'podcast-episode', params: { slug: getStringBetweenMiddleSlashes(story.full_slug), episodeSlug: story.slug } }">
          <v-img
            aspect-ratio="16/9"
            contain
            class="mb-4 mb-md-6"
            :src="
              story.content.main_image.filename +
              '/m/700x394/filters:focal(' +
              story.content.main_image.focus +
              ')'
            "
          ></v-img>
          <authors
            v-if="showReporters && story.content.hosts"
            :reporters="story.content.hosts"
          />
          <p :class="'mb-md-6 ' + (showReporters ? 'mt-3' : 'mt-0 mt-md-6')">{{ story.name }}</p>
        </router-link>
        <router-link v-else :to="{ name: 'article', params: { slug: story.slug } }">
          <v-img
            aspect-ratio="16/9"
            contain
            class="mb-4 mb-md-6"
            :src="
              story.content.header[0].background_image.filename +
              '/m/700x394/filters:focal(' +
              story.content.header[0].background_image.focus +
              ')'
            "
          ></v-img>
          <authors
            v-if="showReporters && story.content.reporters"
            :reporters="story.content.reporters"
          />
          <p :class="'mb-md-6 ' + (showReporters ? 'mt-3' : 'mt-0 mt-md-6')">{{ story.name }}</p>
        </router-link>
      </v-col>
    </v-row>
  </section>
</template>

<style scoped lang="scss">
  .border-top {
    border-top: dotted 1px #000;
    padding-top: 8px;
  }
  .featured-stories {
    padding-top: 4px;
    margin-top: 0;
    .story {
      .v-img {
        margin-bottom: 20px;
      }
      p {
        font-family: "SaansMonoRegular", sans-serif;
        font-size: 0.8125rem;
        line-height: 18px;
        @media only screen and (min-width: 960px) {
          font-size: 1.1875rem;
          line-height: 26px;
        }
      }
    }
  }

  .border-dotted-t {
    border-top: 1px dotted black;
  }
</style>
